import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initializationPromise, isOfflineMode } from './utils/firebase';
import { setupInitialUsers } from './utils/setupInitialUsers';
import { initializeCollections } from './utils/firestoreService';

// Initialize app and set up data
async function initialize() {
  try {
    // Wait for Firebase initialization
    await initializationPromise;

    // Only try to set up data if we're not in offline mode
    if (!isOfflineMode) {
      await Promise.all([
        setupInitialUsers(),
        initializeCollections()
      ]);
    }

    // Render the app
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error: any) {
    console.error('Initialization error:', error);
    
    // Render app anyway - it will handle offline mode
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
}

// Start initialization
initialize();